import React from 'react';
import { Link2, Info } from 'lucide-react';

interface UrlParamsBannerProps {
  pid: string | null;
  uid: string | null;
  status: string | null;
  ip: string | null;
  isCapturing: boolean;
}

export default function UrlParamsBanner({ pid, uid, status, ip, isCapturing }: UrlParamsBannerProps) {
  if (!pid && !uid && !status) return null;

  const statusColors: Record<string, string> = {
    complete: 'text-green-400',
    terminate: 'text-red-400',
    qualitySecurity: 'text-purple-400',
    quotaFull: 'text-amber-400',
  };

  const statusColor = status ? (statusColors[status] ?? 'text-foreground') : 'text-foreground';

  return (
    <div className="glass rounded-xl border border-primary/20 bg-primary/5 px-4 py-3 flex items-center gap-3 fade-in mb-6">
      <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-primary/15 border border-primary/25 flex items-center justify-center">
        <Link2 size={15} className="text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <span className="text-xs font-medium text-primary">URL Params Detected</span>
          {pid && (
            <span className="text-xs text-muted-foreground">
              PID: <span className="text-foreground font-mono font-medium">{pid}</span>
            </span>
          )}
          {uid && (
            <span className="text-xs text-muted-foreground">
              UID: <span className="text-foreground font-mono font-medium">{uid}</span>
            </span>
          )}
          {status && (
            <span className="text-xs text-muted-foreground">
              Status: <span className={`font-medium ${statusColor}`}>{status}</span>
            </span>
          )}
          {ip && (
            <span className="text-xs text-muted-foreground">
              IP: <span className="text-foreground font-mono font-medium">{ip}</span>
            </span>
          )}
          {isCapturing && (
            <span className="text-xs text-primary/70 flex items-center gap-1">
              <Info size={11} />
              Capturing IP…
            </span>
          )}
        </div>
      </div>
    </div>
  );
}